// extracted by mini-css-extract-plugin
var _1 = "sCTIR";
export { _1 as "base" }
